<template>
  <div class="yxt-biz yxtbiz-discuss-speech" v-loading="firstLoading">
    <div class="yxtbiz-discuss-speech__head">
      <div class="yxtbiz-discuss-speech__head__left">
        <span>{{ $t('pc_biz_discuss_speech').d('讨论发言') }}</span>
        <span>{{ total }}</span>
        <yxt-tooltip v-if="speechDesignated" effect="dark" placement="top">
          <template slot="content">
            <div>
              {{
                $t('pc_biz_discuss_reply_tip').d(
                  '学员对他人发言的回复不计入在内'
                )
              }}
            </div>
          </template>
          <yxt-svg
            width="16px"
            height="16px"
            icon-class="question-cirlce-o"
            class="color-gray-6 hover-primary-6 ml4 cursor-pointer"
          />
        </yxt-tooltip>
      </div>
      <div
        class="yxtbiz-discuss-speech__head__right"
        v-if="discussVisible || isPreview || hasCompleted"
      >
        <yxt-dropdown trigger="click" @command="orderByChange">
          <span class="color-59">{{ currentOrderBy.name }}</span>
          <yxt-dropdown-menu slot="dropdown" max-height="300" max-width="300">
            <yxt-dropdown-item
              :class="[
                currentOrderBy.command === item.command
                  ? 'yxt-dropdown-current-item'
                  : ''
              ]"
              :key="index"
              v-for="(item, index) in orderByList"
              :command="item"
              >{{ item.name }}</yxt-dropdown-item
            >
          </yxt-dropdown-menu>
        </yxt-dropdown>
      </div>
    </div>
    <div
      v-infinite-scroll="getComments"
      infinite-scroll-disabled="disabled"
      v-if="discussVisible || isPreview || hasCompleted"
      :infinite-scroll-immediate="false"
    >
      <Speech
        v-bind="$props"
        :data="comment"
        :allow-anonymous="allowAnonymous"
        :board-id="boardId"
        :orderby="orderby"
        :ccConfig="ccConfig"
        v-for="comment in comments"
        :key="comment.id"
        @on-delete="onSpeechDelete"
        @on-replay="onSpeechReplay"
      >
      </Speech>
      <div
        v-if="loading"
        class="yxtbiz-discuss-speech__loading__space"
        v-loading="loading"
        yxt-loading-custom-class="yxtbiz-discuss-speech__loading"
        yxt-loading-size="small"
        :yxt-loading-text="$t('pc_biz_ai_loadding')"
      ></div>
      <div class="yxtbiz-discuss-speech__no-more" v-if="noMore">
        {{ $t('pc_biz_tip_no_more').d('没有更多了') }}
      </div>
    </div>
    <div
      class="yxtbiz-discuss-speech__show-more"
      v-if="!isPreview"
      v-show="!discussVisible && !hasCompleted"
    >
      <span class="hand" @click="discussVisible = true">{{
        $t('pc_biz_discuss_view_other_speech').d('查看他人发言')
      }}</span>
      <yxt-svg
        class="hand"
        @click="discussVisible = true"
        width="16px"
        height="16px"
        icon-class="arrow-down"
      />
    </div>
  </div>
</template>

<script>
import Speech from 'yxt-biz-pc/packages/discuss-speech/src/speech.vue';
import {
  getCcConfig,
  getComment,
  getUserRangeComment
} from 'yxt-biz-pc/packages/discuss-speech/src/service';
import { getFileClass } from 'yxt-biz-pc/packages/discuss-speech/src/utils';
import { debounce } from 'throttle-debounce';
import { DISCUSS_TARGET_CODE_TYPES } from 'yxt-biz-pc/packages/discuss-question/src/enum';

export default {
  name: 'YxtbizDiscussSpeech',
  components: { Speech },
  props: {
    boardId: {
      // 版块id
      type: String,
      required: true
    },
    questionId: {
      // targetId
      type: String,
      required: true
    },
    targetCode: {
      // 学习来源 kng，o2o
      type: String,
      default: DISCUSS_TARGET_CODE_TYPES.O2O
    },
    allowAnonymous: {
      type: Boolean,
      default: false
    },
    hasCompleted: {
      type: Boolean,
      default: true
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    discussTargetId: {
      // 完成任务来源第三方id
      type: String // o2o projectId,kng 传targetId
    },
    speechDesignated: {
      type: Boolean,
      default: false
    },
    speechUserId: {
      type: String,
      default: ''
    },
    isUserSilence: {
      // 用户是否被禁言
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      discussVisible: false,
      firstLoading: true,
      loading: false,
      comments: [],
      currentPage: 1,
      pageSize: 10,
      pages: 0,
      total: 0,
      orderby: 'createTime', // praiseCount
      currentOrderBy: {
        command: 'createTime',
        name: this.$t('pc_biz_discuss_speech_time').d('发言时间')
      },
      orderByList: [
        {
          command: 'createTime',
          name: this.$t('pc_biz_discuss_speech_time').d('发言时间')
        },
        {
          command: 'praiseCount',
          name: this.$t('pc_biz_discuss_speech_hot').d('发言热度')
        }
      ],
      ccConfig: {}
    };
  },
  computed: {
    noMore() {
      return this.currentPage > this.pages;
    },
    disabled() {
      return this.loading || this.noMore;
    }
  },
  mounted() {
    this.firstLoading = true;
    this.resetQuery();
    this.getComments();
    this.getCcConfig();
  },
  watch: {
    questionId(val) {
      if (val) {
        this.firstLoading = true;
        this.resetQuery();
        this.refresh();
      }
    }
  },
  methods: {
    /**
     * 获取讨论发言列表
     */
    getComments: debounce(300, function() {
      if (!this.questionId) return;
      const formData = this.getFormData();
      if (!this.firstLoading) {
        this.loading = true;
      }
      const getCommentApi = this.speechDesignated
        ? getUserRangeComment
        : getComment;
      getCommentApi(this.questionId, formData.query, formData.data)
        .then(result => {
          result.datas.forEach(comment => {
            comment.attachmentList = this.transformAttachment4Discuss(
              comment.attachmentList
            );
          });
          this.comments = [...this.comments, ...result.datas];
          this.pages = result.paging.pages;
          this.total = result.paging.count;
          this.currentPage += 1;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
          this.firstLoading = false;
        });
    }),
    transformAttachment4Discuss(attachmentList) {
      return attachmentList
        .sort((a, b) => a.orderIndex - b.orderIndex)
        .map(item => {
          return {
            fileId: item.fileId,
            name: item.fileName,
            fileType: this.transformFileType(item.fileType, true),
            fileSubType: this.transformFileSubType(item.fileName),
            url: item.fileUrl,
            viewUrl: item.fileType === 0 ? item.coverUrl : undefined,
            fileSize: item.fileSize,
            status: this.transformFileStatus(item.status)
          };
        });
    },
    transformFileType(type, revert) {
      // 1:视频, 2-附件, 3-音频 4-文档  0： 图片
      const types = {
        image: 0,
        video: 1,
        zip: 2,
        audio: 3,
        doc: 4
      };
      if (revert) {
        return Object.keys(types).find(key => types[key] === type);
      }
      return types[type];
    },
    transformFileStatus(status) {
      // 转码状态(0:失败,1:进行中,2:完成)
      // -1 未发起转码 0转码中 1转码成功 2转码失败
      if (status === 0) {
        return 2;
      }
      if (status === 1) {
        return 0;
      }
      if (status === 2) {
        return 1;
      }
    },
    transformFileSubType(fileName) {
      return getFileClass(fileName);
    },
    resetQuery() {
      this.currentPage = 1;
      this.orderby = 'createTime';
    },
    getFormData() {
      const formData = {
        limit: this.pageSize,
        offset: (this.currentPage - 1) * this.pageSize,
        orderby: this.orderby,
        includeReply: 0
      };
      if (this.speechDesignated) {
        // 看指定人
        const query = {
          limit: formData.limit,
          offset: formData.offset
        };
        delete formData.limit;
        delete formData.offset;
        return {
          query,
          data: {
            ...formData,
            stuUserId: this.speechUserId,
            targetType: -1 // 查所有范围内的评论
          }
        };
      } else {
        // 看所有人
        return {
          query: formData
        };
      }
    },
    onSpeechDelete() {
      this.$emit('on-delete');
      this.refresh();
    },
    onSpeechReplay() {
      this.$emit('on-replay');
    },
    refresh(hasCompleted) {
      if (hasCompleted) {
        this.discussVisible = true;
      }
      this.comments = [];
      this.currentPage = 1;
      this.getComments();
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    orderByChange(a, b) {
      this.currentOrderBy = a;
      this.orderby = this.currentOrderBy.command;
      this.refresh();
    },
    getCcConfig() {
      getCcConfig()
        .then(result => {
          this.ccConfig = result;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
